/* THIS IS FILE IS AUTO-GENERATED BY graphql-codegen. DO NOT EDIT THIS FILE DIRECTLY! */
/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
import * as Types from "../../../../../types/definitions/vendor/graphql-schema.d";
import { DocumentNode } from "graphql";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetVisionLookQueryVariables = Types.Exact<{
  lookId: Types.Scalars["ID"]["input"];
  requestOrigin: Types.ExplainTagRequestOrigin;
}>;
export type GetVisionLookQuery = {
  __typename?: "Query";
  client?: {
    __typename?: "Client";
    vision: {
      __typename?: "Vision";
      look?: {
        __typename?: "Look";
        id: string;
        resemblesMeAnswer?: boolean | null;
        image: {
          __typename?: "Image";
          altText: string;
          baseUrl: string;
          mediaPath: string;
        };
        stickerLabel?: {
          __typename?: "ModeStickerLabel";
          label: string;
          theme: Types.ModeStickerLabelTheme;
        } | null;
        feedbackQuestions: Array<{
          __typename?: "LookFeedbackFreeformTextQuestion";
          answer?: string | null;
          id: string;
          label: string;
          placeholderText?: string | null;
          questionId: string;
        } | {
          __typename?: "LookFeedbackMultipleChoiceQuestion";
          answer?: string | null;
          id: string;
          label: string;
          questionId: string;
          options: Array<{
            __typename?: "LookFeedbackMultipleChoiceQuestionOption";
            label: string;
            value: string;
          }>;
        }>;
        shopProductVariants: Array<{
          __typename?: "ShopProductVariant";
          id: string;
          sku: string;
          url: string;
          saved: boolean;
          size: {
            __typename?: "Size";
            id: string;
            name: string;
          };
          color: {
            __typename?: "Color";
            id: string;
            name: string;
          };
          price: {
            __typename?: "Money";
            currency: Types.Currency;
            value: number;
          };
          priceMarkdown?: {
            __typename?: "PriceMarkdown";
            fullPrice: {
              __typename?: "Money";
              currency: Types.Currency;
              value: number;
            };
          } | null;
          image?: {
            __typename?: "ShopMedia";
            baseUrl: string;
            mediaPath: string;
            altText: string;
          } | null;
          shopProduct: {
            __typename?: "ShopProduct";
            name: string;
            brand: {
              __typename?: "Brand";
              id: string;
              name: string;
            };
          };
          inventory: {
            __typename?: "ShopInventory";
            availability: Types.InventoryAvailability;
          };
          stickerLabel?: {
            __typename?: "ModeStickerLabel";
            label: string;
            theme: Types.ModeStickerLabelTheme;
          } | null;
        }>;
      } | null;
    };
  } | null;
};
export const GetVisionLookDocument = {
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "query",
    name: {
      kind: "Name",
      value: "getVisionLook"
    },
    variableDefinitions: [{
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "lookId"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "ID"
          }
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "requestOrigin"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "ExplainTagRequestOrigin"
          }
        }
      }
    }],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "client"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "vision"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "look"
                },
                arguments: [{
                  kind: "Argument",
                  name: {
                    kind: "Name",
                    value: "id"
                  },
                  value: {
                    kind: "Variable",
                    name: {
                      kind: "Name",
                      value: "lookId"
                    }
                  }
                }],
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "id"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "image"
                    },
                    selectionSet: {
                      kind: "SelectionSet",
                      selections: [{
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "altText"
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "baseUrl"
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "mediaPath"
                        }
                      }]
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "stickerLabel"
                    },
                    selectionSet: {
                      kind: "SelectionSet",
                      selections: [{
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "label"
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "theme"
                        }
                      }]
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "resemblesMeAnswer"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "feedbackQuestions"
                    },
                    selectionSet: {
                      kind: "SelectionSet",
                      selections: [{
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "answer"
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "id"
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "label"
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "questionId"
                        }
                      }, {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: {
                            kind: "Name",
                            value: "LookFeedbackFreeformTextQuestion"
                          }
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "answer"
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "id"
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "label"
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "placeholderText"
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "questionId"
                            }
                          }]
                        }
                      }, {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: {
                            kind: "Name",
                            value: "LookFeedbackMultipleChoiceQuestion"
                          }
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "answer"
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "id"
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "label"
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "options"
                            },
                            selectionSet: {
                              kind: "SelectionSet",
                              selections: [{
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "label"
                                }
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "value"
                                }
                              }]
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "questionId"
                            }
                          }]
                        }
                      }]
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "shopProductVariants"
                    },
                    selectionSet: {
                      kind: "SelectionSet",
                      selections: [{
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "id"
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "sku"
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "url"
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "saved"
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "size"
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "id"
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "name"
                            }
                          }]
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "color"
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "id"
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "name"
                            }
                          }]
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "price"
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "currency"
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "value"
                            }
                          }]
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "priceMarkdown"
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "fullPrice"
                            },
                            selectionSet: {
                              kind: "SelectionSet",
                              selections: [{
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "currency"
                                }
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "value"
                                }
                              }]
                            }
                          }]
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "image"
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "baseUrl"
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "mediaPath"
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "altText"
                            }
                          }]
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "shopProduct"
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "name"
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "brand"
                            },
                            selectionSet: {
                              kind: "SelectionSet",
                              selections: [{
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "id"
                                }
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "name"
                                }
                              }]
                            }
                          }]
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "inventory"
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "availability"
                            }
                          }]
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "stickerLabel"
                        },
                        arguments: [{
                          kind: "Argument",
                          name: {
                            kind: "Name",
                            value: "requestOrigin"
                          },
                          value: {
                            kind: "Variable",
                            name: {
                              kind: "Name",
                              value: "requestOrigin"
                            }
                          }
                        }],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "label"
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "theme"
                            }
                          }]
                        }
                      }]
                    }
                  }]
                }
              }]
            }
          }]
        }
      }]
    }
  }]
} as unknown as DocumentNode;

/**
 * __useGetVisionLookQuery__
 *
 * To run a query within a React component, call `useGetVisionLookQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVisionLookQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVisionLookQuery({
 *   variables: {
 *      lookId: // value for 'lookId'
 *      requestOrigin: // value for 'requestOrigin'
 *   },
 * });
 */
export function useGetVisionLookQuery(baseOptions: Apollo.QueryHookOptions<GetVisionLookQuery, GetVisionLookQueryVariables> & ({
  variables: GetVisionLookQueryVariables;
  skip?: boolean;
} | {
  skip: boolean;
})) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useQuery<GetVisionLookQuery, GetVisionLookQueryVariables>(GetVisionLookDocument, options);
}
export function useGetVisionLookLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVisionLookQuery, GetVisionLookQueryVariables>) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useLazyQuery<GetVisionLookQuery, GetVisionLookQueryVariables>(GetVisionLookDocument, options);
}
// @ts-ignore
export function useGetVisionLookSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVisionLookQuery, GetVisionLookQueryVariables>): Apollo.UseSuspenseQueryResult<GetVisionLookQuery, GetVisionLookQueryVariables>;
export function useGetVisionLookSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVisionLookQuery, GetVisionLookQueryVariables>): Apollo.UseSuspenseQueryResult<GetVisionLookQuery | undefined, GetVisionLookQueryVariables>;
export function useGetVisionLookSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVisionLookQuery, GetVisionLookQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useSuspenseQuery<GetVisionLookQuery, GetVisionLookQueryVariables>(GetVisionLookDocument, options);
}
export type GetVisionLookQueryHookResult = ReturnType<typeof useGetVisionLookQuery>;
export type GetVisionLookLazyQueryHookResult = ReturnType<typeof useGetVisionLookLazyQuery>;
export type GetVisionLookSuspenseQueryHookResult = ReturnType<typeof useGetVisionLookSuspenseQuery>;
export type GetVisionLookQueryResult = Apollo.QueryResult<GetVisionLookQuery, GetVisionLookQueryVariables>;